export default function() {
    return (
        <>
            <h1 className="fiction">Submissions</h1>
            <p style={{color: "white", width: "400px", maxWidth: "95%", margin: "0 auto", fontSize: "1.25em"}}>Coming soon... reach out to me on Twitter @RichHosek if you think you have a Bedtime Story that would be a good fit for Insomniacs</p>
        </>
    )
}